import { adminInterface } from '../systems/admin-interface.js'
import { NotAuthenticatedPage } from '../ui/NotAuthenticatedPage.js'

export const notAuthorizedAdminPageElement = adminInterface.createNotAuthorizedAdminPage(NotAuthenticatedPage)
